<template>
  <div class="text-xl font-bold mx-7 my-7">
    <span>{{ store }}の応募期間は</span><br />
    <span>{{ formattedBegin }} ～ {{ formattedEnd }}です。</span>
  </div>
</template>

<script lang="ts">
import dayjs from 'dayjs';
import { defineComponent } from 'vue';

import { useState } from '@/hooks/use_state';

export default defineComponent({
  name: 'ContentTieUpConfirm',
  setup() {
    const state = useState();
    const store = state.value.store;
    const begin = dayjs.tz(state.value.begin, 'Asia/Tokyo');
    const end = dayjs.tz(state.value.end, 'Asia/Tokyo');
    const adjustedEnd = end.subtract(1, 'second'); //UV的に1秒引かないと表示がおかしくなる
    const formattedBegin = begin.format('YYYY年M月D日');
    const formattedEnd = adjustedEnd.format('YYYY年M月D日');
    return {
      store,
      formattedBegin,
      formattedEnd,
    };
  },
});
</script>

<style lang="scss" scoped>

</style>
